import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LANGS = [
  { code: "fr", flag: "🇫🇷", label: "FR" },
  { code: "en", flag: "🇬🇧", label: "EN" },
];

export default function LanguageSwitcher({ variant = "navbar" }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "fr").split("-")[0];

  const set = (code) => {
    i18n.changeLanguage(code);
    try { localStorage.setItem("monrepetiteur_lang", code); } catch (e) { /* noop */ }
  };

  if (variant === "compact") {
    return (
      <div className="inline-flex items-center rounded-full border border-[#E5EBE7] bg-white p-0.5" role="group" aria-label={t("lang.switcherAria")}>
        {LANGS.map((l) => {
          const active = current === l.code;
          return (
            <button
              key={l.code}
              type="button"
              onClick={() => set(l.code)}
              data-testid={`lang-switch-${l.code}`}
              className={`text-xs font-medium px-2.5 py-1 rounded-full transition-colors ${
                active ? "bg-[#16A34A] text-white" : "text-[#0A2518] hover:bg-[#F0FDF4]"
              }`}
              aria-pressed={active}
            >
              <span aria-hidden className="mr-1">{l.flag}</span>{l.label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-1" role="group" aria-label={t("lang.switcherAria")}>
      <Globe className="h-4 w-4 text-[#16A34A]" aria-hidden />
      {LANGS.map((l) => {
        const active = current === l.code;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => set(l.code)}
            data-testid={`lang-switch-${l.code}`}
            className={`text-sm font-medium px-2 py-1 rounded-md transition-colors ${
              active ? "text-[#16A34A] bg-[#F0FDF4]" : "text-[#0A2518]/70 hover:text-[#16A34A]"
            }`}
            aria-pressed={active}
            title={t(`lang.${l.code}`)}
          >
            <span aria-hidden className="mr-1">{l.flag}</span>{l.label}
          </button>
        );
      })}
    </div>
  );
}
